import ConfigProvider from './Core/Configuration/ConfigProvider';

export function Initialize() {
    const $document = $(document);
    const $body = $('body');
    const $header = $('#header');
    const $menuToggle = $header.find('.menu-toggle');
    const $menuToggleText = $menuToggle.find('span');
    const $inputBusqueda = $header.find('#busqueda');
    const $buttonBuscar = $header.find('#btnBuscar');

    // Menú. 
    $menuToggle.click(() => {
        if ($body.hasClass('menu-open')) {
            $menuToggleText.html('MEN&Uacute');
            $body.removeClass('menu-open');
        }
        else {
            $body.addClass('menu-open');
            $menuToggleText.html('CERRAR');
        }
    });

    $document.click((e) => {
        if (e.target.id !== 'header' && $(e.target).parents('header').length === 0) {
            if ($body.hasClass('menu-open')) {
                $menuToggleText.html('MEN&Uacute');
                $body.removeClass('menu-open');
            }
        }
    });

    // Búsqueda.
    $buttonBuscar.click(() => {
        const searchValue = $inputBusqueda.val();

        window.location.href = `${ConfigProvider.BuscadorUrl}${searchValue}`;
    });

    $inputBusqueda.keypress((e) => {
        if (e.keyCode === 13) {
            $buttonBuscar.click();
        }
    });
}


// WEBPACK FOOTER //
// ./Statics/scripts/Header.js